import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type FormData } from "@client/controls/Form/component";
import { apiAction } from "@client/lib/actions";
import { goTo } from "@client/lib/navigation";
import { TargetSelector } from "@client/selectors";
import { type BaseAppState, type EntityRef, Status } from "@client/types";
import { type AnyAction, type Dispatch } from "redux";
import api from "../Cart/api";
import { type Cart } from "../Cart/types";
import { redirect } from "../actions";
import { localStateSelector, makeAddToCartParamsSelector } from "./selectors";

export enum Actions {
  AddToCartBegin = "CHECKOUT_BUTTON_ADD_TO_CART_BEGIN",
  AddToCartFailure = "CHECKOUT_BUTTON_ADD_TO_CART_FAILURE",
  AddToCartSuccess = "CHECKOUT_BUTTON_ADD_TO_CART_SUCCESS"
}

export type AddToCartBeginActionData = EntityRef & {
  quantity?: number;
  variant?: string;
};

export type AddToCartSuccessActionData = Cart.Api.AddResponse & {};
const _addToCart = apiAction<BaseAppState, AddToCartBeginActionData, AddToCartSuccessActionData>({
  types: {
    begin: Actions.AddToCartBegin,
    failure: Actions.AddToCartFailure,
    success: [
      async ({ dispatch, getState, params, res }) => {
        const p = makeAddToCartParamsSelector()(getState(), params);
        if (p.confirmation === "default") {
          goTo(p.action === "add" ? res.cartUrl : res.checkoutUrl);
        } else {
          await dispatch(
            redirect({
              id: params.id,
              source: params.source,
              target: TargetSelector.Entity
            })
          );
        }
      },
      Actions.AddToCartSuccess
    ]
  },
  action: (state: BaseAppState, dispatch: Dispatch<AnyAction>, args: AddToCartBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    const params = makeAddToCartParamsSelector()(state, args);
    return api.add(apiInfo, {
      quantity: args.quantity || params.quantity!,
      variantId: args.variant || params.variant!,
      resetCart: params.resetCart
    });
  }
});

export const submit = (ref: EntityRef, data: FormData) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, { id: ref.id });

  if (localState.status !== Status.Saving) {
    dispatch(_addToCart({ ...ref, quantity: data.quantity, variant: data.variant }));
  }
};
